define("shared/utils/is-stringified-json", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.isStringifiedJSON = _exports.default = isStringifiedJSON;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function isStringifiedJSON(str) {
    if (typeof str !== 'string') return false;
    try {
      return typeof JSON.parse(str) === 'object';
    } catch (err) {
      return false;
    }
  }
});